/* tslint:disable */
/* eslint-disable */
/**
 * Copyright Innov'ATM all rights reserved. This software is the property of Innov'ATM and may not be used in any
 * manner except under a license agreement signed with Innov'ATM.
 *
 * AK RMS API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */

export enum AccessPermissions {
    'RESOURCE_MANAGEMENT' = 'RESOURCE_MANAGEMENT',
    'RULE_MANAGEMENT' = 'RULE_MANAGEMENT',
    'RESOURCE_ALLOCATION' = 'RESOURCE_ALLOCATION',
    'PRE_TACTICAL_MANAGEMENT' = 'PRE_TACTICAL_MANAGEMENT',
    'TACTICAL_MANAGEMENT' = 'TACTICAL_MANAGEMENT',
    'CONFIGURATION_MANAGEMENT' = 'CONFIGURATION_MANAGEMENT',
    'PAST_MANAGEMENT' = 'PAST_MANAGEMENT'
}
